module.exports = __webpack_public_path__ + "media/images/flags/16/Palestine-e1f2ee6c40fb8ec4f7a21ee41d0cd78a.png";